import React, { useEffect, AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconPerformanceOutline } from '@saucelabs/ds-icons';

import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import { PERFORMANCE_MODE_ENABLED_KEY } from '../../../constants';
import * as globalSelectors from '../../../selectors';
import constants from '../constants';
import selectors from '../selectors';
import operations from '../operations';
import GenericButton from './GenericButton';

const { ENABLED } = constants.PERFORMANCE_MODE_STATES;

const PerformanceModeButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    device,
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const {
    isPerformanceModeEnabled,
  } = useSelector(globalSelectors.mobileSessionSelector);

  useEffect(() => {
    const performanceModeState = localStorage.getItem(PERFORMANCE_MODE_ENABLED_KEY) || ENABLED;
    void dispatch(operations.setPerformanceMode(performanceModeState === ENABLED));
  }, [dispatch]);

  const togglePerformanceMode = () => {
    void dispatch(operations.setPerformanceMode(!isPerformanceModeEnabled));

    trackEvent(TOOLBAR_TRACKING_NAMES.PERFORMANCE_MODE, {
      deviceType,
      roomId: device?.webRtcRoomId || 'unknown',
      testType,
      value: !isPerformanceModeEnabled,
    });
  };

  return (
    <GenericButton
      disabled={deviceToolsDisabled}
      icon={IconPerformanceOutline}
      label="Performance Mode"
      onPress={togglePerformanceMode}
      role={role}
      status={isPerformanceModeEnabled}
    />
  );
};

PerformanceModeButton.displayName = 'PerformanceModeButton';

export default PerformanceModeButton;
